<div class="container-fluid-boxed p-0">
  <form class="d-flex flex-row align-items-center flex-wrap p-2">
    <h2 class="my-1 me-2">Company Power Ranking</h2>
<!--    <select class="form-select my-1 me-sm-2 w-auto">-->
<!--      <option>Company</option>-->
<!--      <option>Director</option>-->
<!--    </select>-->
  </form>
  <carousel [cellWidth]="315" [height]="160">
    <app-company-card class="carousel-cell" *ngFor="let company of boards" [company]="company"></app-company-card>
  </carousel>
</div>
